import { render } from "./ConfirmationDialog.vue?vue&type=template&id=66c4a866"
import script from "./confirmation-dialog-component.ts?vue&type=script&lang=js&external"
export * from "./confirmation-dialog-component.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__